import React from 'react';
import i18n from  '../i18n.js';
import en from '../svg/en.svg';
import nl from '../svg/nl.svg';
import fr from '../svg/fr.svg';

const changeLanguage = (ln) =>{
    return () => {
        i18n.changeLanguage(ln);
        console.log(`Language changed to ${ln}`);
    }
}

function Topbar() {
 
    return (       
        <div id="topbar" className="d-flex align-items-center fixed-top">
            <div className="container d-flex">
                <div className="contact-info me-auto">
                    {/* Icon Call - open modal1 */}
                    <i className="fas fa-phone-alt" data-bs-toggle="modal" data-bs-target="#exampleModalCenter" ></i>       
                    <button data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                        +32 2 502 17 29
                    </button>
                     {/* Icon Mail - open modal2 */}
                     <i className="fas fa-envelope" data-bs-toggle="modal" data-bs-target="#exampleModalCenter2" ></i>
                     <button data-bs-toggle="modal" data-bs-target="#exampleModalCenter2">
                         info@oldtbilisi.be
                    </button>
                    {/* Icon Position - open modal3 */}
                    <i className="fas fa-map-marker-alt" data-bs-toggle="modal" data-bs-target="#exampleModalCenter3" ></i>
                    {/* Icon Instagram */}
                    <a href="https://www.instagram.com/old_tbilisii/" target="_blank" rel="noreferrer">
                    <i className="fab fa-instagram"></i>
                    </a>                     
                    {/* Icon Facebook */}
                    <a href="https://www.facebook.com/oldtbilisi2021/" target="_blank" rel="noreferrer">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                    {/* Icon Google Rate us / Write review */}
                    <a href="https://www.google.com/search?hl=en-BE&gl=be&q=Old+Tbilisi,+Nieuwstraat+20,+1730+Asse&ludocid=3911857777478912669&lsig=AB86z5Uuhg4bYWu02xHLGLNOMZSo#lrd=0x47c3bf6ba3d7e179:0x3649b5ec367aca9d,1" rel="noreferrer" target="_blank"><i className="fab fa-google"></i>
                    </a>
                </div>
                <div className="languages ">
                    <ul>
                        <li><button onClick={changeLanguage("en")}>En<img className="img-fluid max-lang" src={en} alt="Language selection: English"></img></button></li>
                        <li><button onClick={changeLanguage("nl")}>Nl<img className="img-fluid max-lang" src={nl} alt="Language selection: Ducth"></img></button></li>
                        <li><button onClick={changeLanguage("fr")}>Fr<img className="img-fluid max-lang" src={fr} alt="Language selection: French"></img></button></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Topbar;
